import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RefreshProjectsService {
  refreshProjects = new Subject();

  constructor() {}
}
